import { getMessages } from '../../../../store/constants';

export const SKIP_TO_MAIN_TEXT = getMessages().getText('accessibility.skip_to_main');
